import { fromZonedTime } from 'date-fns-tz';

export const UTA_BRUSSELS_TZ = 'Europe/Brussels';

/** YYYY-MM-DD du jour civil à Bruxelles pour un instant UTC. */
export function formatYmdInBrussels(isoOrDate) {
    const d = new Date(isoOrDate);
    if (Number.isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat('en-CA', {
        timeZone: UTA_BRUSSELS_TZ,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(d);
}

/** Heure locale Bruxelles (HH:mm) pour un instant UTC. */
export function formatHmInBrussels(isoOrDate) {
    const d = new Date(isoOrDate);
    if (Number.isNaN(d.getTime())) return '14:30';
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: UTA_BRUSSELS_TZ,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(d);
    const h = parts.find((p) => p.type === 'hour')?.value;
    const m = parts.find((p) => p.type === 'minute')?.value;
    if (h == null || m == null) return '14:30';
    return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`;
}

/**
 * ymd (YYYY-MM-DD) + heure « HH:mm » ou « HH:mm:ss » (Bruxelles) → instant UTC.
 */
export function brusselsInstantFromYmdAndHm(ymd, hm) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return new Date(NaN);
    const s = String(hm ?? '').trim();
    const m = /^(\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec(s);
    if (!m) return new Date(NaN);
    const hh = m[1].padStart(2, '0');
    const mm = m[2].padStart(2, '0');
    const ss = (m[3] ?? '00').padStart(2, '0');
    return fromZonedTime(`${ymd} ${hh}:${mm}:${ss}`, UTA_BRUSSELS_TZ);
}

/** Fin d’événement ce jour civil (ymd) à partir d’une heure stockée type « 16:30:00 ». */
export function brusselsInstantFromYmdAndDbEndTime(ymd, endTime) {
    const raw = endTime && String(endTime).trim() ? String(endTime).trim() : '16:30:00';
    return brusselsInstantFromYmdAndHm(ymd, raw);
}

/** Début d’événement : 14h30 à Bruxelles ce jour-là → instant UTC. */
export function brusselsScheduleStartUtc(isoOrDate) {
    const ymd = formatYmdInBrussels(isoOrDate);
    if (!ymd) return new Date(NaN);
    return brusselsInstantFromYmdAndHm(ymd, '14:30:00');
}

/** Fin d’événement : 16h30 à Bruxelles ce jour-là → instant UTC. */
export function brusselsScheduleEndUtc(isoOrDate) {
    const ymd = formatYmdInBrussels(isoOrDate);
    if (!ymd) return new Date(NaN);
    return brusselsInstantFromYmdAndHm(ymd, '16:30:00');
}

/** Aujourd’hui (jour civil Bruxelles) en YYYY-MM-DD — défaut formulaire admin. */
export function todayYmdBrussels() {
    return formatYmdInBrussels(new Date());
}

/** Construit l’instant UTC de début (14:30) à partir d’une date YYYY-MM-DD (fallback / seed). */
export function brusselsStartUtcFromYmd(ymd) {
    return brusselsInstantFromYmdAndHm(ymd, '14:30:00');
}
